module.exports = __webpack_public_path__ + "48f59a7afd25b232fd7086bf53cfd62d.png";